import { Link } from "@/app/components/lib/navigation/Link";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { PropsWithChildren } from "react";

const BlogLinkWrapper: React.FC<
  PropsWithChildren & { slug: number | string }
> = ({ children, slug }) => (
  <Link prefetch={false} href={`${PagesPaths.blogDetails}${slug}`} style={{color:"inherit"}}>
    {children}
  </Link>
);
export default BlogLinkWrapper;
